module.exports = __webpack_public_path__ + "static/media/usc_logo.18872506.png";